// TODO: crypto package is not available on browser, so we need to find a way to use createHash on browser
//import { createHash } from 'crypto';
import { isBrowser } from './browser';

export const hexOfSha256 = (text: string): string => {
    // TODO: crypto package is not available on browser, so we need to find a way to use createHash on browser
    // const hash = createHash('sha256');
    // hash.update(text);
    // return hash.digest('hex');
    return 'NA';
};

export const anyToBase64 = (text: any): string => {
    if (isBrowser()) {
        return btoa(text);
    }
    return Buffer.from(text).toString('base64');
};

export const base64ToAny = (text: string): any => {
    if (isBrowser()) {
        return atob(text);
    }
    return Buffer.from(text, 'base64').toString('ascii');
};
